<!--
  - Copyright (c) 2020. Minerva Networks.
  - All rights reserved.
  -->

<template>
  <div :class="theClass ? theClass : 'playPause'">
    <svg v-if="playerState.playing" width="34px" height="34px" viewBox="0 0 60 60"
         version="1.1"
         xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
         @click="pause()">
      <!-- Generator: Sketch 48.2 (47327) - http://www.bohemiancoding.com/sketch -->
      <desc>Created with Sketch.</desc>
      <defs></defs>
      <g id="Real-Madrid-Pass---tablet-/-landscape" stroke="none" stroke-width="1" fill="none"
         fill-rule="evenodd">
        <g id="Real-Madrid-Pass---Live-TV---full-screen-A"
           transform="translate(-73.000000, -232.000000)">
          <g id="Group-2" transform="translate(73.000000, 232.000000)">
            <rect id="Rectangle" fill-opacity="0.5" fill="#000000" x="0" y="0" width="60"
                  height="60" rx="30"></rect>
            <g id="Graphics-/-Custom-Icons-/-Player-/-Pause"
               transform="translate(22.000000, 21.000000)" fill="#FFFFFF">
              <path
                d="M5.45454545,0 C5.75563636,0 6,0.252 6,0.5625 L6,17.4375 C6,17.748 5.75563636,18 5.45454545,18 L0.545454545,18 C0.244363636,18 -1.13686838e-13,17.748 -1.13686838e-13,17.4375 L-1.13686838e-13,0.5625 C-1.13686838e-13,0.252 0.244363636,0 0.545454545,0 L5.45454545,0 Z M15.4545455,0 C15.7556364,0 16,0.252 16,0.5625 L16,17.4375 C16,17.748 15.7556364,18 15.4545455,18 L10.5454545,18 C10.2443636,18 10,17.748 10,17.4375 L10,0.5625 C10,0.252 10.2443636,0 10.5454545,0 L15.4545455,0 Z"
                id="Icon"></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
    <svg v-else width="34px" height="34px" viewBox="0 0 60 60" version="1.1"
         xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink" @click="play()">
      <!-- Generator: Sketch 48.2 (47327) - http://www.bohemiancoding.com/sketch -->
      <desc>Created with Sketch.</desc>
      <defs></defs>
      <g id="Real-Madrid-Pass---tablet-/-landscape" stroke="none" stroke-width="1" fill="none"
         fill-rule="evenodd">
        <g id="Group-2">
          <rect id="Rectangle" fill-opacity="0.5" fill="#000000" x="0" y="0" width="60" height="60"
                rx="30"></rect>
          <g id="Graphics-/-Custom-Icons-/-Player-/-Play-Small"
             transform="translate(24.000000, 21.000000)"
             fill="#FFFFFF">
            <path
              d="M6.7298677,1.96095215 C7.29232793,1.01099923 8.2066456,1.01503482 8.76671639,1.96095215 L16.50478,15.0299581 C17.0672403,15.979911 16.6323885,16.75 15.522904,16.75 L-0.0263198967,16.75 C-1.13105529,16.75 -1.56826672,15.9758754 -1.00819593,15.0299581 L6.7298677,1.96095215 Z"
              id="Play"
              transform="translate(7.750000, 9.000000) rotate(90.000000) translate(-7.750000, -9.000000) "></path>
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>
<script lang="js">
export default {
  props: [
    'playerState',
    'playerInstance',
    'theClass',
  ],
  methods: {
    play() {
      this.playerInstance.play();
    },
    pause() {
      this.playerInstance.pause();
    },
  },
};
</script>
